import { render, staticRenderFns } from "./VacancyCardPopup.vue?vue&type=template&id=56478332&"
import script from "./VacancyCardPopup.vue?vue&type=script&lang=js&"
export * from "./VacancyCardPopup.vue?vue&type=script&lang=js&"
import style0 from "./VacancyCardPopup.vue?vue&type=style&index=0&id=56478332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports